class VoiceSlide {
  constructor(el, opt) {
    this.el = el;
    if ($("." + this.el).length > 0) {
      this.event();
    }
  }
  event() {
    if (window.matchMedia("(min-width: 768px)").matches) {
      var voiceSwiper = new Swiper(".js-voice-swiper", {
        slidesPerView: 3,
        spaceBetween: 45,
        pagination: {
          el: ".voicepagination",
          clickable: true,
        },
        navigation: {
          nextEl: ".js-voice-next",
          prevEl: ".js-voice-prev",
        },
        breakpoints: {
          768: {
            slidesPerView: 3,
            spaceBetween: 45,
          }
        },
      });
    }
  }
}